import * as React from "react";

import styles from "./PageHeading.module.css";

export interface PageHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  initial?: string;
  className?: string;
}

export const PageHeading: React.FC<PageHeadingProps> = ({ title, subtitle, icon, initial, className }) => (
  <div className={`${styles.heading}${className ? ` ${className}` : ""}`}>
    <span className={styles.avatar}>
      {icon ? <i className={`fa-solid ${icon}`} /> : initial}
    </span>
    <div>
      <h1 className={styles.headingTitle}>{title}</h1>
      {subtitle && <p className={styles.headingSubtitle}>{subtitle}</p>}
    </div>
  </div>
);
